import { ComponentProps } from 'react';
import { Switch as AriaSwitch } from 'react-aria-components';
import {
  SwitchStylesVariants,
  switchStyles,
  switchStylesIndicator,
} from './variant';

type Props = {
  className?: string;
  onChange: (value: boolean) => void;
} & Omit<
  ComponentProps<typeof AriaSwitch>,
  'children' | 'className' | 'onChange'
> &
  SwitchStylesVariants;

export function Switch(props: Props) {
  const { className, intent, onChange, value, ...rest } = props;

  return (
    <AriaSwitch
      className="group cursor-pointer"
      onChange={onChange}
      value={value}
      {...rest}
    >
      <div className={switchStyles({ intent })}>
        <span className={switchStylesIndicator({ intent })} />
      </div>
    </AriaSwitch>
  );
}
